import { render } from "./ChooseExportSize.vue?vue&type=template&id=8faf6000&scoped=true"
import script from "./ChooseExportSize.vue?vue&type=script&lang=js"
export * from "./ChooseExportSize.vue?vue&type=script&lang=js"

import "./ChooseExportSize.vue?vue&type=style&index=0&id=8faf6000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faf6000"]])

export default __exports__